import { render, staticRenderFns } from "./AnnouncementTableView.vue?vue&type=template&id=04dd63e3&"
import script from "./AnnouncementTableView.vue?vue&type=script&lang=ts&"
export * from "./AnnouncementTableView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports